var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('p',{class:_vm.scaduto ? 'scaduto' : null,attrs:{"id":"scadenza"}},[_c('span',{staticClass:"intestazione-scadenza"},[_vm._v(_vm._s(_vm.scaduto ? "Scaduto il" : "Scadenza:")+" ")]),_c('span',{attrs:{"id":"data-scadenza"}},[_vm._v(_vm._s(_vm.scadenza))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }